module.exports = __webpack_public_path__ + "img/20_7.f8613567.png";